module.exports = __webpack_public_path__ + "img/icon-home-office-filter.d0e0daf2.svg";